import React from 'react';
import {observer} from 'mobx-react';
import {FormError, Button, TextArea, SliderBar, ProgressIndicator, AutosaveStatus} from 'components';
import {FormattedMessage} from 'react-intl';

const ProgressUpdateForm = observer(({uiState}) => {
  const {goal, progressUpdate, changesMade, errors} = uiState;

  if (!goal.canUpdateProgress) {
    return (
      <div className='mt2'>
        <div className='table-cell jumbo pr1'>
          {`${goal.completeness}%`}
        </div>
        <div className='table-cell full-width'>
          <ProgressIndicator items={goal.progressBarItems} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <SliderBar
        showLabels={false}
        value={progressUpdate.completeness}
        onChange={value => uiState.updateCompleteness(value)}
      />
      <TextArea
        value={progressUpdate.comment}
        onChange={e => uiState.updateComment(e.target.value)}
        helpMessage='goals.Add a comment or update the progress by dragging the slider'
      />
      <FormError message={errors.base} />
      <div className='right-align mt2'>
        <AutosaveStatus autosaver={progressUpdate.autosaver} className='mr2' />
        <Button size='sm' onClick={() => uiState.saveProgressUpdate()} disabled={!changesMade}>
          <FormattedMessage id='goals.Add progress'/>
        </Button>
      </div>
    </div>
  );
});

export default ProgressUpdateForm;
